import React from "react";
import { List, ListItem } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ListContext } from "./useList";
import { ListItemEditor } from "./ListItemEditor";
import { ElementTag } from "./ElementTag";
import { toNumber } from "../core/utils/conversion";

export function ListEditor(props: {
	list: List,
}) {
	const designer = useDesigner();

	// const parentListItem = useListItem();

	const {
		list,
	} = props;

	const listState = React.useMemo(() => {
		return {
			list,
			
			number: 0, // set below
			style: "",

			addItem: function(after: ListItem) {

				const newItem = designer.createItem("listItem") as ListItem;
				if (newItem) {
					designer.addItem(newItem, list.items, after, 1);
				}

				// once everything re-rendered we want the new para to be focused
				designer.setFocus(newItem.content[0]);
				designer.refreshItem(list);
			},
		};
	}, [designer, list]);

	listState.number = toNumber(props.list.start, 1);
	if (listState.number < 1) listState.number = 1;
	listState.style = props.list.style ? props.list.style : designer.structure.defaults.listStyle;

	const items = [];
	for(let li of props.list.items) {
		if (!li.id) li.id = designer.nextID();
		if (li.type !== "listItem") li.type = "listItem";

		items.push(
			<ListItemEditor item={li} number={listState.number} key={li.id} />
		);

		listState.number++;
	}

	const elementContext = useElementContext(props.list);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {
		console.log("focus: list");

	}, []));

	const style = designer.createStyle(props.list);

	return (
		<ElementContext.Provider value={elementContext}>
			<ListContext.Provider value={listState}>
				<div
					className={"list-editor content-element " + state.classes}
					data-key={props.list.id}
					id={state.elementID}

					tabIndex={0}

					style={style}
					key={state.token}
				>
					<ElementTag />
					{items}
				</div>
			</ListContext.Provider>
		</ElementContext.Provider>
	);
}
